var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"Hamburger",class:{ open : _vm.isOpen },attrs:{"aria-label":"Toggle mobile navigation menu"},on:{"click":function($event){return _vm.toggle()}}},_vm._l((3),function(i){return _c('div',{staticClass:"bar"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }